import { useCallback } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { getSignedMediaUrl } from '@/lib/utils';

export const useUserProfile = () => {
  const { user, isAuthenticated, isLoading } = useAuth();



  // Get profile picture URL
  const getProfilePictureUrl = useCallback(() => {
    if (!user) return null;

    // Generate URL from profile_picture_id if available
    if (user.profile_picture_id && user.profile_picture_id !== '00000000-0000-0000-0000-000000000000') {
      return getSignedMediaUrl(user.profile_picture_id, 'image').url;
    }

    // Fallback to generated URL
    return `https://api.placeholder.com/40x40/6366f1/ffffff?text=${user.first_name.charAt(0).toUpperCase()}`;
  }, [user]);

  return {
    user,
    isAuthenticated,
    isLoading,
    profilePictureUrl: getProfilePictureUrl(),
    // Keep these for backward compatibility if needed, or remove if unused elsewhere
    fetchAndCacheUserData: async () => useAuth().refetch(),
    clearCachedUserData: () => { }, // No-op as we don't cache locally anymore
    hasAuthCookie: () => document.cookie.includes('auth_token') || document.cookie.includes('session')
  };
};
